import { FC } from 'react';
import styles from './Stick.module.scss';

export interface StickProps {
    title: string;
    img: string;
    color: string;
}

const Stick: FC<StickProps> = ({ img, color, title }) => {
    return (
        <div className={styles.stick}>
            <img
                src={img}
                alt=""
            />

            <p style={{ color }}>{title}</p>
        </div>
    );
};

export default Stick;
